import { MessageCircle } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export default function WhatsAppButton() {
  const { settings } = useSettings();
  const href = `https://wa.me/${settings.whatsapp_phone}?text=${encodeURIComponent(settings.whatsapp_message)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Parliamo del tuo progetto su WhatsApp"
      className="fixed bottom-6 right-6 z-40 group flex items-center gap-2 bg-ink text-bone px-4 py-3 hover:bg-gold transition-colors shadow-lg"
    >
      <MessageCircle size={18} strokeWidth={1.6} />
      <span className="text-[11px] tracking-[0.16em] uppercase hidden sm:inline">
        Parliamo del tuo progetto
      </span>
    </a>
  );
}
